import { render, staticRenderFns } from "./PaintingModePage.vue?vue&type=template&id=478895b6&"
import script from "./PaintingModePage.vue?vue&type=script&lang=ts&"
export * from "./PaintingModePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports